Map.prototype.valuesArray = function <V>(): V[] {
	return Array.from(this.values());
};

Map.prototype.keysArray = function <K>(): K[] {
	return Array.from(this.keys());
};

Map.prototype.keysSet = function <K>(): Set<K> {
	return new Set(this.keys());
};

Map.prototype.entryArray = function <K, V>(): [K, V][] {
	return Array.from(this.entries());
};

Map.prototype.hasValue = function <V>(value: V): boolean {
	for (const v of this.values()) {
		if (v === value) return true;
	}
	return false;
};

Map.prototype.filter = function <K, V>(filter: (value: V, key: K) => boolean): Map<K, V> {
	const result = new Map<K, V>();
	this.forEach((value: V, key: K) => {
		if (filter(value, key)) {
			result.set(key, value);
		}
	});
	return result;
};

Map.prototype.fromObject = function <K extends string | number | symbol, V>(object: Record<K, V>): Map<K, V> {
	const map = new Map<K, V>();
	for (const key in object) {
		if (Object.prototype.hasOwnProperty.call(object, key)) {
			map.set(key, object[key]);
		}
	}
	return map;
};

Map.prototype.getValue = function <K, V>(keyOrValue: K | V): V | undefined {
	for (const [key, value] of this.entries()) {
		if (key === keyOrValue || value === keyOrValue) return value;
	}
	return undefined;
};

export {};
